// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1ppTK","col":"styles_col__2gCLu"};